module.exports = __webpack_public_path__ + "static/img/sjThree.fa18c81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sjThree.png
// module id = QKqT
// module chunks = 1